/**
 * Central role model — SINGLE source of truth for v3 role authorization.
 */

export const SCHOOL_ADMIN_ROLES = ['school_admin', 'tenant_admin'];
export const SUPER_ADMIN_ROLES = ['super_admin', 'organization_super_admin', 'organization_superadmin', 'platform_admin', 'admin'];

export const ROLE_ALIASES = {
  tenant_admin: 'school_admin',
  organization_superadmin: 'organization_super_admin',
  superadmin: 'super_admin',
};

export const canonicalRole = (role) => (role ? ROLE_ALIASES[role] || role : '');

export const isSchoolAdminRole = (role) => SCHOOL_ADMIN_ROLES.includes(role);

export const isSuperAdminRole = (role) => SUPER_ADMIN_ROLES.includes(role) || SUPER_ADMIN_ROLES.includes(canonicalRole(role));

/**
 * True when `role` matches any of `allowedRoles`, after normalizing aliases.
 *
 * Strict boundary: every guard must list the exact roles it admits. There is
 * NO blanket cross-access between admin ecosystems — a guard that lists only
 * School Super Admin roles does NOT admit the Organization Super Admin (and
 * vice-versa). Ecosystem access is defined per-route in AppV3.js.
 */
export const roleAllowed = (role, allowedRoles = []) => {
  if (!role) return false;
  const canonical = canonicalRole(role);
  return allowedRoles.some((allowed) => canonicalRole(allowed) === canonical);
};
